<template>
  <modal
    ref="modal"
    class="service-modal"
    title="Novo serviço"
    :showModal="true"
    @close="closeModal"
  >
    <template v-slot:body>
      <ValidationObserver
        v-slot="{ passes }"
        ref="form"
      >
        <form id="form" @submit.prevent="passes(submit)">
          <div class="body">
            <div class="section">
              <div class="fields">
                <div class="field">
                  <input-field-component
                    class="input-field-component"
                    placeholder="Descrição do serviço"
                    rules="required"
                    v-model="data.description"
                  />

                  <input-currency-field
                    class="input-field-component small"
                    placeholder="Valor de venda"
                    type="money"
                    rules="required"
                    v-model="data.price"
                  />
                </div>

                <!-- <div class="field">
                  <input-field-component
                    class="input-field-component"
                    placeholder="Nomenclatura Brasileira de Serviço (NBS)"
                    rules="required"
                  />
                </div> -->

                <div class="field">
                  <input-field-component
                    class="input-field-component medium"
                    placeholder="Código de referêcia"
                    v-model="data.referenceId"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </template>

    <template v-slot:footer>
      <div class="footer-slot-container">
        <div class="button-container">
          <button-component
            class="button-component"
            styles="ghost"
            text="Fechar"
            :isDisabled="hasRequest"
            @click.native="closeModal"
            v-ripple="$theme.secondColorDarkTransparent"
          />

          <button-component
            class="button-component"
            text="Salvar"
            form="form"
            :hasLoader="hasRequest"
            :isDisabled="hasRequest"
            v-ripple="$theme.whiteColorTransparent"
          />
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
  import { ValidationObserver } from 'vee-validate';
  import Modal from '@/components/Modal/Base';
  import InputField from '@/components/Base/InputField';
  import InputCurrencyField from '@/components/Base/InputCurrencyField';
  import Button from '@/components/Base/Button';

  export default {
    name: 'ServiceModal',

    data() {
      return {
        hasRequest: false,
        data: {
          description: '',
          price: '',
          referenceId: ''
        }
      };
    },

    components: {
      ValidationObserver,
      'modal': Modal,
      'input-field-component': InputField,
      'input-currency-field': InputCurrencyField,
      'button-component': Button,
    },

    methods: {
      async submit() {
        this.hasRequest = true;

        const body = {
          description: this.data.description,
          price: this.data.price,
          reference_id: this.data.referenceId
        };

        await this.$store.dispatch('serviceModule/postService', JSON.stringify(body))
          .then(() => {
            this.snackbarNotification('Serviço cadastrado com sucesso', '#08B978');

            this.$emit('finishRequest');
          })
          .catch(() => {
            this.snackbarNotification('Erro ao cadastrar serviço. Tente novamente', '#FF5A5A');
          });

        this.closeModal();

        this.hasRequest = false;
      },

      closeModal() {
        this.$emit('close');
      },

      snackbarNotification(text, color) {
        this.$emit('snackbarNotification', text, color);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .service-modal {
    form {
      .body {
        margin-top: 1.5rem;
        padding: 0 1.5rem;
        width: 560px;
        overflow-y: auto;

        .section {
          padding: 0.5rem;

          .fields {
            .field {
              display: flex;
              gap: 0.5rem;

              .input-field-component {
                width: 100%;

                &.medium {
                  max-width: 250px;
                }

                &.small {
                  max-width: 175px;
                }
              }
            }
          }
        }
      }
    }

    .footer-slot-container {
      display: flex;
      justify-content: flex-end;
      padding: 0.75rem 1rem;
      box-shadow: 0px -1px 6px rgba(0, 0, 0, 0.08);

      .button-container {
        display: flex;

        .button-component {
          width: 100px;
          height: 48px;
          margin-left: 1rem;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .service-modal {
      form {
        .body {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 520px) {
    .service-modal {
      form {
        .body {
          .fields {
            .field {
              flex-direction: column;
              margin-bottom: 1rem;
              gap: unset !important;

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
</style>